// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/organization.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateCustomDomainRequest, CreateCustomDomainResponse, CreateDomainVerificationRequest, CreateDomainVerificationResponse, CreateOrganizationInviteRequest, CreateOrganizationInviteResponse, CreateOrganizationRequest, CreateOrganizationResponse, CreateSCIMConfigurationRequest, CreateSCIMConfigurationResponse, CreateSSOConfigurationRequest, CreateSSOConfigurationResponse, DeleteCustomDomainRequest, DeleteCustomDomainResponse, DeleteDomainVerificationRequest, DeleteDomainVerificationResponse, DeleteOrganizationRequest, DeleteOrganizationResponse, DeleteSCIMConfigurationRequest, DeleteSCIMConfigurationResponse, DeleteSSOConfigurationRequest, DeleteSSOConfigurationResponse, GetAnnouncementBannerRequest, GetAnnouncementBannerResponse, GetCustomDomainRequest, GetCustomDomainResponse, GetDomainVerificationRequest, GetDomainVerificationResponse, GetOrganizationInviteRequest, GetOrganizationInviteResponse, GetOrganizationInviteSummaryRequest, GetOrganizationInviteSummaryResponse, GetOrganizationPoliciesRequest, GetOrganizationPoliciesResponse, GetOrganizationRequest, GetOrganizationResponse, GetSCIMConfigurationRequest, GetSCIMConfigurationResponse, GetSSOConfigurationRequest, GetSSOConfigurationResponse, JoinOrganizationRequest, JoinOrganizationResponse, LeaveOrganizationRequest, LeaveOrganizationResponse, ListDomainVerificationsRequest, ListDomainVerificationsResponse, ListMembersRequest, ListMembersResponse, ListSCIMConfigurationsRequest, ListSCIMConfigurationsResponse, ListSSOConfigurationsRequest, ListSSOConfigurationsResponse, RegenerateSCIMTokenRequest, RegenerateSCIMTokenResponse, SetRoleRequest, SetRoleResponse, SetStripeCustomerIDRequest, SetStripeCustomerIDResponse, SetTierRequest, SetTierResponse, UpdateAnnouncementBannerRequest, UpdateAnnouncementBannerResponse, UpdateCustomDomainRequest, UpdateCustomDomainResponse, UpdateOrganizationPoliciesRequest, UpdateOrganizationPoliciesResponse, UpdateOrganizationRequest, UpdateOrganizationResponse, UpdateSCIMConfigurationRequest, UpdateSCIMConfigurationResponse, UpdateSSOConfigurationRequest, UpdateSSOConfigurationResponse, VerifyDomainRequest, VerifyDomainResponse } from "./organization_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.OrganizationService
 */
export const OrganizationService = {
  typeName: "gitpod.v1.OrganizationService",
  methods: {
    /**
     * Creates a new organization with the specified name and settings.
     *
     * Use this method to:
     * - Create a new organization for team collaboration
     * - Set up automatic domain-based invites for team members
     * - Join the organization immediately upon creation
     *
     * ### Examples
     *
     * - Create a basic organization:
     *
     *   Creates an organization with just a name.
     *
     *   ```yaml
     *   name: "Acme Corp Engineering"
     *   joinOrganization: true
     *   ```
     *
     * - Create with domain-based invites:
     *
     *   Creates an organization that automatically invites users with matching email domains.
     *
     *   ```yaml
     *   name: "Acme Corp"
     *   joinOrganization: true
     *   inviteAccountsWithMatchingDomain: true
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.CreateOrganization
     */
    createOrganization: {
      name: "CreateOrganization",
      I: CreateOrganizationRequest,
      O: CreateOrganizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Allows users to join an organization through direct ID, invite link, or domain-based auto-join.
     *
     * Use this method to:
     * - Join an organization via direct ID or invite
     * - Join automatically based on email domain
     * - Accept organization invitations
     *
     * ### Examples
     *
     * - Join via organization ID:
     *
     *   Joins an organization directly when you have the ID.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * - Join via invite:
     *
     *   Accepts an organization invitation link.
     *
     *   ```yaml
     *   inviteId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.JoinOrganization
     */
    joinOrganization: {
      name: "JoinOrganization",
      I: JoinOrganizationRequest,
      O: JoinOrganizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific organization.
     *
     * Use this method to:
     * - Retrieve organization settings and configuration
     * - Check organization membership status
     * - View domain verification settings
     *
     * ### Examples
     *
     * - Get organization details:
     *
     *   Retrieves information about a specific organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetOrganization
     */
    getOrganization: {
      name: "GetOrganization",
      I: GetOrganizationRequest,
      O: GetOrganizationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates an organization's settings including name, invite domains, and member policies.
     *
     * Use this method to:
     * - Modify organization display name
     * - Configure email domain restrictions
     * - Update organization-wide settings
     * - Manage member access policies
     *
     * ### Examples
     *
     * - Update basic settings:
     *
     *   Changes organization name and invite domains.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   name: "New Company Name"
     *   inviteDomains:
     *     domains:
     *       - "company.com"
     *       - "subsidiary.com"
     *   ```
     *
     * - Remove domain restrictions:
     *
     *   Clears all domain-based invite restrictions.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   inviteDomains:
     *     domains: []
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.UpdateOrganization
     */
    updateOrganization: {
      name: "UpdateOrganization",
      I: UpdateOrganizationRequest,
      O: UpdateOrganizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Permanently deletes an organization.
     *
     * Use this method to:
     * - Remove unused organizations
     * - Clean up test organizations
     * - Complete organization migration
     *
     * ### Examples
     *
     * - Delete organization:
     *
     *   Permanently removes an organization and all its data.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.DeleteOrganization
     */
    deleteOrganization: {
      name: "DeleteOrganization",
      I: DeleteOrganizationRequest,
      O: DeleteOrganizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists and filters organization members with optional pagination.
     *
     * Use this method to:
     * - View all organization members
     * - Monitor member activity
     * - Manage team membership
     *
     * ### Examples
     *
     * - List active members:
     *
     *   Retrieves active members with pagination.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - List with pagination:
     *
     *   Retrieves next page of members.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 50
     *     token: "next-page-token-from-previous-response"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.ListMembers
     */
    listMembers: {
      name: "ListMembers",
      I: ListMembersRequest,
      O: ListMembersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Manages organization membership and roles by setting a user's role within the organization.
     *
     * Use this method to:
     * - Promote members to admin role
     * - Change member permissions
     * - Demote admins to regular members
     *
     * ### Examples
     *
     * - Promote to admin:
     *
     *   Makes a user an organization administrator.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   role: ORGANIZATION_ROLE_ADMIN
     *   ```
     *
     * - Change to member:
     *
     *   Changes a user's role to regular member.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   role: ORGANIZATION_ROLE_MEMBER
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.SetRole
     */
    setRole: {
      name: "SetRole",
      I: SetRoleRequest,
      O: SetRoleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates an invite link for joining an organization.
     * Any existing OrganizationInvites are invalidated and can no longer be used.
     *
     * Use this method to:
     * - Generate shareable invite links
     * - Manage team growth
     * - Control organization access
     *
     * ### Examples
     *
     * - Create organization invite:
     *
     *   Generates a new invite link for the organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.CreateOrganizationInvite
     */
    createOrganizationInvite: {
      name: "CreateOrganizationInvite",
      I: CreateOrganizationInviteRequest,
      O: CreateOrganizationInviteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.OrganizationService.GetOrganizationInvite
     */
    getOrganizationInvite: {
      name: "GetOrganizationInvite",
      I: GetOrganizationInviteRequest,
      O: GetOrganizationInviteResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves organization details and membership info based on an invite link.
     *
     * Use this method to:
     * - Preview organization details before joining
     * - Validate invite link authenticity
     * - Check organization size and activity
     * - View team information before accepting
     *
     * ### Examples
     *
     * - Get invite summary:
     *
     *   Retrieves organization information from an invite.
     *
     *   ```yaml
     *   inviteId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetOrganizationInviteSummary
     */
    getOrganizationInviteSummary: {
      name: "GetOrganizationInviteSummary",
      I: GetOrganizationInviteSummaryRequest,
      O: GetOrganizationInviteSummaryResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Removes a user from an organization while preserving organization data.
     *
     * Use this method to:
     * - Remove yourself from an organization
     * - Clean up inactive memberships
     * - Transfer project ownership before leaving
     * - Manage team transitions
     *
     * ### Examples
     *
     * - Leave organization:
     *
     *   Removes user from organization membership.
     *
     *   ```yaml
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * Note: Ensure all projects and resources are transferred before leaving.
     *
     * @generated from rpc gitpod.v1.OrganizationService.LeaveOrganization
     */
    leaveOrganization: {
      name: "LeaveOrganization",
      I: LeaveOrganizationRequest,
      O: LeaveOrganizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates or updates SSO configuration for organizational authentication.
     *
     * Use this method to:
     * - Configure OIDC-based SSO providers
     * - Set up built-in providers (Google, GitHub, etc.)
     * - Define custom identity providers
     * - Manage authentication policies
     *
     * ### Examples
     *
     * - Configure built-in Google SSO:
     *
     *   Sets up SSO using Google Workspace.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   clientId: "012345678-abcdefghijklmnopqrstuvwxyz.apps.googleusercontent.com"
     *   clientSecret: "GOCSPX-abcdefghijklmnopqrstuvwxyz123456"
     *   issuerUrl: "https://accounts.google.com"
     *   emailDomain: "acme-corp.com"
     *   ```
     *
     * - Configure custom OIDC provider:
     *
     *   Sets up SSO with a custom identity provider.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   clientId: "acme-corp-gitpod"
     *   clientSecret: "secret-token-value"
     *   issuerUrl: "https://sso.acme-corp.com"
     *   emailDomain: "acme-corp.com"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.CreateSSOConfiguration
     */
    createSSOConfiguration: {
      name: "CreateSSOConfiguration",
      I: CreateSSOConfigurationRequest,
      O: CreateSSOConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves a specific SSO configuration.
     *
     * Use this method to:
     * - View SSO provider details
     * - Check configuration status
     * - Verify SSO settings
     *
     * ### Examples
     *
     * - Get SSO configuration:
     *
     *   Retrieves details of a specific SSO configuration.
     *
     *   ```yaml
     *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetSSOConfiguration
     */
    getSSOConfiguration: {
      name: "GetSSOConfiguration",
      I: GetSSOConfigurationRequest,
      O: GetSSOConfigurationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists and filters SSO configurations for an organization.
     *
     * Use this method to:
     * - View all SSO providers
     * - Monitor authentication status
     * - Audit security settings
     * - Manage provider configurations
     *
     * ### Examples
     *
     * - List active configurations:
     *
     *   Shows all active SSO providers.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - List by provider type:
     *
     *   Shows custom SSO configurations.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *     token: "next-page-token-from-previous-response"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.ListSSOConfigurations
     */
    listSSOConfigurations: {
      name: "ListSSOConfigurations",
      I: ListSSOConfigurationsRequest,
      O: ListSSOConfigurationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Removes an SSO configuration from an organization.
     *
     * Use this method to:
     * - Disable SSO authentication
     * - Remove outdated providers
     * - Clean up unused configurations
     *
     * ### Examples
     *
     * - Delete SSO configuration:
     *
     *   Removes a specific SSO configuration.
     *
     *   ```yaml
     *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.DeleteSSOConfiguration
     */
    deleteSSOConfiguration: {
      name: "DeleteSSOConfiguration",
      I: DeleteSSOConfigurationRequest,
      O: DeleteSSOConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates SSO provider settings and authentication rules.
     *
     * Use this method to:
     * - Rotate client credentials
     * - Update provider endpoints
     * - Modify claim mappings
     * - Change authentication policies
     * - Toggle SSO enforcement
     *
     * ### Examples
     *
     * - Update credentials:
     *
     *   Rotates client ID and secret.
     *
     *   ```yaml
     *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   clientId: "new-client-id"
     *   clientSecret: "new-client-secret"
     *   ```
     *
     * - Update provider status:
     *
     *   Activates or deactivates SSO provider.
     *
     *   ```yaml
     *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   state: SSO_CONFIGURATION_STATE_ACTIVE
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.UpdateSSOConfiguration
     */
    updateSSOConfiguration: {
      name: "UpdateSSOConfiguration",
      I: UpdateSSOConfigurationRequest,
      O: UpdateSSOConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new SCIM configuration for automated user provisioning.
     *
     * Use this method to:
     * - Set up SCIM 2.0 provisioning from an identity provider
     * - Generate a bearer token for SCIM API authentication
     * - Link SCIM provisioning to an existing SSO configuration
     *
     * ### Examples
     *
     * - Create basic SCIM configuration:
     *
     *   Creates a SCIM configuration linked to an SSO provider.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ssoConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.CreateSCIMConfiguration
     */
    createSCIMConfiguration: {
      name: "CreateSCIMConfiguration",
      I: CreateSCIMConfigurationRequest,
      O: CreateSCIMConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves a specific SCIM configuration.
     *
     * Use this method to:
     * - View SCIM configuration details
     * - Check if SCIM is enabled
     * - Verify SSO linkage
     *
     * ### Examples
     *
     * - Get SCIM configuration:
     *
     *   Retrieves details of a specific SCIM configuration.
     *
     *   ```yaml
     *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetSCIMConfiguration
     */
    getSCIMConfiguration: {
      name: "GetSCIMConfiguration",
      I: GetSCIMConfigurationRequest,
      O: GetSCIMConfigurationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists SCIM configurations for an organization.
     *
     * Use this method to:
     * - View all SCIM configurations
     * - Monitor provisioning status
     * - Audit SCIM settings
     *
     * ### Examples
     *
     * - List SCIM configurations:
     *
     *   Shows all SCIM configurations for an organization.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.ListSCIMConfigurations
     */
    listSCIMConfigurations: {
      name: "ListSCIMConfigurations",
      I: ListSCIMConfigurationsRequest,
      O: ListSCIMConfigurationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a SCIM configuration.
     *
     * Use this method to:
     * - Enable or disable SCIM provisioning
     * - Link or unlink SSO configuration
     * - Update configuration name
     *
     * ### Examples
     *
     * - Disable SCIM:
     *
     *   Disables SCIM provisioning.
     *
     *   ```yaml
     *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   enabled: false
     *   ```
     *
     * - Link to SSO:
     *
     *   Links SCIM configuration to an SSO provider.
     *
     *   ```yaml
     *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ssoConfigurationId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.UpdateSCIMConfiguration
     */
    updateSCIMConfiguration: {
      name: "UpdateSCIMConfiguration",
      I: UpdateSCIMConfigurationRequest,
      O: UpdateSCIMConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Removes a SCIM configuration from an organization.
     *
     * Use this method to:
     * - Disable SCIM provisioning completely
     * - Remove unused configurations
     * - Clean up after migration
     *
     * ### Examples
     *
     * - Delete SCIM configuration:
     *
     *   Removes a specific SCIM configuration.
     *
     *   ```yaml
     *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.DeleteSCIMConfiguration
     */
    deleteSCIMConfiguration: {
      name: "DeleteSCIMConfiguration",
      I: DeleteSCIMConfigurationRequest,
      O: DeleteSCIMConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Regenerates the bearer token for a SCIM configuration.
     *
     * Use this method to:
     * - Rotate SCIM credentials
     * - Recover from token compromise
     * - Update IdP configuration
     *
     * ### Examples
     *
     * - Regenerate token:
     *
     *   Creates a new bearer token, invalidating the old one.
     *
     *   ```yaml
     *   scimConfigurationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.RegenerateSCIMToken
     */
    regenerateSCIMToken: {
      name: "RegenerateSCIMToken",
      I: RegenerateSCIMTokenRequest,
      O: RegenerateSCIMTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates domain verification process to enable organization features.
     *
     * Use this method to:
     * - Start domain ownership verification
     * - Enable automatic team joining
     * - Set up SSO restrictions
     * - Configure email-based policies
     *
     * ### Examples
     *
     * - Verify primary domain:
     *
     *   Starts verification for main company domain.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   domain: "acme-corp.com"
     *   ```
     *
     * - Verify subsidiary domain:
     *
     *   Adds verification for additional company domain.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   domain: "acme-subsidiary.com"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.CreateDomainVerification
     */
    createDomainVerification: {
      name: "CreateDomainVerification",
      I: CreateDomainVerificationRequest,
      O: CreateDomainVerificationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves the status of a domain verification request.
     *
     * Use this method to:
     * - Check verification progress
     * - View verification requirements
     * - Monitor domain status
     *
     * ### Examples
     *
     * - Get verification status:
     *
     *   Checks the current state of a domain verification.
     *
     *   ```yaml
     *   domainVerificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetDomainVerification
     */
    getDomainVerification: {
      name: "GetDomainVerification",
      I: GetDomainVerificationRequest,
      O: GetDomainVerificationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists and monitors domain verification status across an organization.
     *
     * Use this method to:
     * - Track verification progress
     * - View all verified domains
     * - Monitor pending verifications
     * - Audit domain settings
     *
     * ### Examples
     *
     * - List all verifications:
     *
     *   Shows all domain verifications regardless of status.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - List with pagination:
     *
     *   Retrieves next page of verifications.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   pagination:
     *     pageSize: 20
     *     token: "next-page-token-from-previous-response"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.ListDomainVerifications
     */
    listDomainVerifications: {
      name: "ListDomainVerifications",
      I: ListDomainVerificationsRequest,
      O: ListDomainVerificationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Verifies domain ownership for an organization.
     *
     * Use this method to:
     * - Complete domain verification process
     * - Enable domain-based features
     * - Validate DNS configuration
     *
     * ### Examples
     *
     * - Verify domain ownership:
     *
     *   Verifies ownership after DNS records are configured.
     *
     *   ```yaml
     *   domainVerificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.VerifyDomain
     */
    verifyDomain: {
      name: "VerifyDomain",
      I: VerifyDomainRequest,
      O: VerifyDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Removes a domain verification request.
     *
     * Use this method to:
     * - Cancel pending verifications
     * - Remove verified domains
     * - Clean up unused domain records
     *
     * ### Examples
     *
     * - Delete verification:
     *
     *   Removes a domain verification request.
     *
     *   ```yaml
     *   domainVerificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.DeleteDomainVerification
     */
    deleteDomainVerification: {
      name: "DeleteDomainVerification",
      I: DeleteDomainVerificationRequest,
      O: DeleteDomainVerificationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets organization policy settings by organization ID.
     *
     * Use this method to:
     * - Retrieve current policy settings for an organization
     * - View resource limits and restrictions
     * - Check allowed editors and other configurations
     *
     * ### Examples
     *
     * - Get organization policies:
     *
     *   Retrieves policy settings for a specific organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetOrganizationPolicies
     */
    getOrganizationPolicies: {
      name: "GetOrganizationPolicies",
      I: GetOrganizationPoliciesRequest,
      O: GetOrganizationPoliciesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates organization policy settings.
     *
     * Use this method to:
     * - Configure editor restrictions
     * - Set environment resource limits
     * - Define project creation permissions
     * - Customize default configurations
     *
     * ### Examples
     *
     * - Update editor policies:
     *
     *   Restricts available editors and sets a default.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   allowedEditorIds:
     *     - "vscode"
     *     - "jetbrains"
     *   defaultEditorId: "vscode"
     *   ```
     *
     * - Set environment limits:
     *
     *   Configures limits for environment usage.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   maximumEnvironmentTimeout: "3600s"
     *   maximumRunningEnvironmentsPerUser: "5"
     *   maximumEnvironmentsPerUser: "20"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.UpdateOrganizationPolicies
     */
    updateOrganizationPolicies: {
      name: "UpdateOrganizationPolicies",
      I: UpdateOrganizationPoliciesRequest,
      O: UpdateOrganizationPoliciesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves the announcement banner configuration for an organization.
     *
     * Use this method to fetch the current announcement banner settings.
     * All organization members can read the banner configuration.
     *
     * ### Examples
     *
     * - Get announcement banner:
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetAnnouncementBanner
     */
    getAnnouncementBanner: {
      name: "GetAnnouncementBanner",
      I: GetAnnouncementBannerRequest,
      O: GetAnnouncementBannerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the announcement banner configuration for an organization.
     *
     * Use this method to configure the announcement banner displayed to all users.
     * Only organization admins can update the banner. Requires Enterprise tier.
     *
     * ### Examples
     *
     * - Enable announcement banner:
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   message: "Scheduled maintenance on Saturday 10pm-2am UTC"
     *   enabled: true
     *   ```
     *
     * - Disable announcement banner:
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   enabled: false
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.UpdateAnnouncementBanner
     */
    updateAnnouncementBanner: {
      name: "UpdateAnnouncementBanner",
      I: UpdateAnnouncementBannerRequest,
      O: UpdateAnnouncementBannerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets the tier of an organization.
     *
     * Use this method to:
     * - Change an organization's tier between free, core, and enterprise
     *
     * ### Examples
     *
     * - Set organization tier:
     *
     *   Changes organization tier to enterprise.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   tier: ORGANIZATION_TIER_ENTERPRISE
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.SetTier
     */
    setTier: {
      name: "SetTier",
      I: SetTierRequest,
      O: SetTierResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets the Stripe customer ID for an organization's billing configuration.
     *
     * Use this method to associate an existing Stripe customer with an organization
     * during enterprise customer onboarding.
     *
     * ### Examples
     *
     * - Set Stripe customer ID:
     *
     *   Associates a Stripe customer with an organization.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   stripeCustomerId: "cus_ABC123"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.SetStripeCustomerID
     */
    setStripeCustomerID: {
      name: "SetStripeCustomerID",
      I: SetStripeCustomerIDRequest,
      O: SetStripeCustomerIDResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a custom domain configuration for an organization.
     *
     * Use this method to configure custom domains for organization workspaces
     *
     * ### Examples
     *
     * - Configure AWS custom domain:
     *
     *   Sets up a custom domain with AWS provider.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   domainName: "workspaces.acme-corp.com"
     *   provider: CUSTOM_DOMAIN_PROVIDER_AWS
     *   awsAccountId: "123456789012"
     *   ```
     *
     *
     * @generated from rpc gitpod.v1.OrganizationService.CreateCustomDomain
     */
    createCustomDomain: {
      name: "CreateCustomDomain",
      I: CreateCustomDomainRequest,
      O: CreateCustomDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves a specific custom domain configuration.
     *
     * Use this method to view custom domain details
     *
     * ### Examples
     *
     * - Get custom domain configuration:
     *
     *   Retrieves details of a specific custom domain.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.GetCustomDomain
     */
    getCustomDomain: {
      name: "GetCustomDomain",
      I: GetCustomDomainRequest,
      O: GetCustomDomainResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates custom domain configuration settings.
     *
     * Use this method to:
     * - Update cloud provider settings
     * - Change AWS account ID
     * - Modify domain configuration
     *
     * ### Examples
     *
     * - Update AWS account ID:
     *
     *   Changes the AWS account ID for the custom domain.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   domainName: "workspaces.acme-corp.com"
     *   awsAccountId: "987654321098"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.UpdateCustomDomain
     */
    updateCustomDomain: {
      name: "UpdateCustomDomain",
      I: UpdateCustomDomainRequest,
      O: UpdateCustomDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Removes a custom domain configuration from an organization.
     *
     * Use this method to:
     * - Disable custom domain functionality
     * - Remove outdated configurations
     * - Clean up unused domains
     *
     * ### Examples
     *
     * - Delete custom domain configuration:
     *
     *   Removes a specific custom domain configuration.
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * @generated from rpc gitpod.v1.OrganizationService.DeleteCustomDomain
     */
    deleteCustomDomain: {
      name: "DeleteCustomDomain",
      I: DeleteCustomDomainRequest,
      O: DeleteCustomDomainResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

